define('bizzabo/views/popup/PopupView',[
    'jquery',
    'backbone',
    'bootstrap/bootstrap'
], function(
    $,
    Backbone
    ) {

    var PopupView = Backbone.View.extend({

        modalOptions : {
            keyboard : false,
            backdrop : 'static'
        },

        popUpInitialize : function() {
            var thisView = this;
            this.$el.addClass('modal');
            this.$el.on('hidden', function() {
                thisView.remove();
            });
            this.$el.on('shown', function() {
                thisView.viewRendered();
            });
        },

        initialize : function() {
            this.popUpInitialize();
        },

        show : function() {
            this.render();
            this.$el.appendTo($('body'));
            this.$el.addClass('modal').addClass('hide').addClass('fade').modal(this.modalOptions);

            // Center vertically
            var thisView = this;
            this.$el.css({
                'margin-top' : (thisView.$el.height() / -2)
            });
        },

        viewRendered : function() {
            // Override this in subclass (called after view was rendered)
        },

        hide : function() {
            this.$el.modal('hide');
        },

        popupRemove : function() {
            this.$el.off('hidden');
            this.$el.off('shown');
            this.$el.remove();
            this.off();
        },

        remove : function() {
            this.popupRemove();
        }
    });

    return PopupView;

});
